<template>
  <div>
    <el-input
      class="input2"
      :value="value"
      :placeholder="placeholder"
      @input="inputChange($event)"
      @change="change($event)"
      @keyup.enter.native="change"
      :style="{ width: width + 'px' }"
    >
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <!-- 使用方式 <v-input className="t" v-model="name" placeholder="xxx"/>-->
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    width: {
      type: String,
      default: "auto"
    },
    placeholder: {
      type: String,
      default: "搜索"
    }
  },
  data() {
    return {};
  },
  methods: {
    inputChange(val) {
      this.$emit("input", val);
    },
    change() {
      this.$emit("change", this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .input2 {
  border: 1px solid #f2f2f2;
  background: white;
  border-radius: 40px;
  overflow: hidden;
  &:hover {
    border: 1px solid #409eff !important;
  }

  .el-input__prefix {
    // left: 16px;
    top: 2px;
  }
  .el-input__inner {
    display: inline-block !important;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Vinput/index.vue